<template lang="pug">
v-container(fluid class=" tw-h-full tw-w-full")
  v-row(no-gutters align="center" justify="center" class="tw-w-full tw-h-full")
    v-col(class="tw-rounded-md tw-h-full tw-w-full tw-ml-2 tw-flex tw-flex-col ")
      v-row(class="  tw-flex !tw-flex-shrink-default ")
        v-col
          span(class="tw-text-2xl tw-text-indigo-lighten-1 tw-font-bold tw-capitalize") {{ $t('Profile.Common.settings') }}
      v-row(align="start" class="  tw-flex tw-flex-row !tw-flex-grow-defaul tw-h-full ")
        v-col
          v-select(
            :items="locale_options"
            v-model="user.locale"
            :label="$t('Profile.Common.language')"
            outlined
            class="tw-capitalize"
          )
      v-row(no-gutters justify="end" class="  tw-flex tw-flex-row !tw-flex-shrink-default")
        v-col(cols="auto" align-self="end")
          v-btn(
            elevation="0"
            @click="update"
            :loading="loading"
            color="rgba(94,129,244,0.80)"
            class="tw-bg-kPurple tw-rounded"
          ) {{ $t('Common.save') }}
      v-divider(class="tw-my-6")
      v-row(v-if="deletionEligibilityLoading || deletionEligibilityError || deletion.enabled" no-gutters)
        v-col
          h2(class="tw-text-lg tw-font-bold tw-text-red-700") {{ $t('Settings.Common.deleteAccountTitle') }}
          p(class="tw-mt-2 tw-text-sm tw-text-gray-700") {{ $t('Settings.Common.deleteAccountDescription') }}
          p(v-if="deletionEligibilityLoading" role="status" class="tw-mt-4 tw-text-sm tw-text-gray-600") {{ $t('Settings.Common.deleteAccountLoading') }}
          v-alert(v-if="deletionEligibilityError" type="error" outlined class="tw-mt-4") {{ deletionEligibilityError }}
          template(v-if="deletion.enabled")
            p(class="tw-mt-2 tw-text-sm tw-text-gray-700") {{ $t('Settings.Common.deleteAccountBackupNote') }}
            v-alert(v-if="deletionError && !deletionDialog" type="error" outlined class="tw-mt-4") {{ deletionError }}
            v-alert(v-if="deletion.request" type="info" outlined class="tw-mt-4")
              | {{ $t('Settings.Common.deleteAccountPending', { status: deletion.request.status }) }}
            v-alert(
              v-if="deletion.teams && deletion.teams.some((team) => !team.eligible)"
              type="warning"
              outlined
              class="tw-mt-4"
            )
              p(v-for="team in deletion.teams" :key="team.team_id || team.name" class="tw-mb-1")
                | {{ team.name }}:
                span(v-if="team.is_owner") {{ $t('Settings.Common.deleteAccountOwnerSteps') }}
                router-link(v-if="team.is_owner" :to="{ name: 'settingsTeam' }") {{ $t('Settings.Common.deleteAccountGoToAgencySettings') }}
                span(v-else-if="team.is_only_admin") {{ $t('Settings.Common.deleteAccountAdminSteps') }}
                router-link(v-if="team.is_only_admin" :to="{ name: 'settingsTeam' }") {{ $t('Settings.Common.deleteAccountGoToAgencySettings') }}
                span(v-else-if="!team.eligible") {{ $t('Settings.Common.deleteAccountTeamBlock') }}
                span(v-else) {{ $t('Settings.Common.deleteAccountTeamReady') }}
            v-btn(
              v-if="!deletion.request"
              color="error"
              outlined
              class="tw-mt-3"
              :disabled="!deletion.eligible || deletionLoading"
              @click="beginDeletionRequest"
            ) {{ $t('Settings.Common.deleteAccountButton') }}
      v-dialog(v-model="deletionDialog" max-width="560" persistent)
        v-card
          v-card-title {{ deletionStep === 'reauth' ? $t('Settings.Common.deleteAccountVerifyTitle') : $t('Settings.Common.deleteAccountConfirmTitle') }}
          v-card-text
            template(v-if="deletionStep === 'reauth'")
              p {{ $t('Settings.Common.deleteAccountVerifyDescription') }}
              v-text-field(
                v-model="deletionPassword"
                :label="$t('Settings.Common.currentPassword')"
                type="password"
                autocomplete="current-password"
              )
              v-text-field(
                v-if="deletion.two_factor_enabled"
                v-model="deletionCode"
                :label="$t('Settings.Common.twoFactorCode')"
                autocomplete="one-time-code"
              )
              p(class="tw-text-sm tw-text-gray-600") {{ $t('Settings.Common.deleteAccountGoogleNote') }}
            template(v-else)
              p {{ $t('Settings.Common.deleteAccountFinalWarning') }}
              p {{ $t('Settings.Common.deleteAccountBackupNote') }}
              p(class="tw-font-medium") {{ $t('Settings.Common.deleteAccountScopeTitle') }}
              p {{ deletion.email }}
              p(v-for="team in deletion.teams" :key="team.team_id || team.name" class="tw-mb-1")
                | {{ team.name }} —
                span(v-if="team.is_owner") {{ $t('Settings.Common.deleteAccountOwnerBlock') }}
                span(v-else-if="team.is_only_admin") {{ $t('Settings.Common.deleteAccountAdminBlock') }}
                span(v-else) {{ $t('Settings.Common.deleteAccountTeamReady') }}
              p(class="tw-font-medium") {{ $t('Settings.Common.deleteAccountAgencyWarning') }}
              v-text-field(v-model="deletionConfirmation" :label="$t('Settings.Common.typeDelete')" autocomplete="off")
              v-text-field(
                v-model="deletionEmail"
                :label="$t('Settings.Common.accountEmail')"
                type="email"
                autocomplete="email"
              )
            v-alert(v-if="deletionError" type="error" dense outlined) {{ deletionError }}
          v-card-actions
            v-spacer
            v-btn(text @click="closeDeletionDialog") {{ $t('Common.cancel') }}
            v-btn(
              v-if="deletionStep === 'reauth'"
              color="primary"
              :loading="deletionLoading"
              @click="reauthenticateForDeletion"
            ) {{ $t('Settings.Common.continue') }}
            v-btn(
              v-else
              color="error"
              :loading="deletionLoading"
              :disabled="deletionConfirmation !== 'DELETE' || deletionEmail.toLowerCase() !== deletion.email.toLowerCase()"
              @click="submitDeletionRequest"
            ) {{ $t('Settings.Common.submitDeletionRequest') }}
</template>
<script>
import { apiClient } from '@/services/API';

export default {
  data() {
    return {
      user: {},
      loading: false,
      deletion: { enabled: false, teams: [], request: null, two_factor_enabled: false, eligible: false, email: '' },
      deletionEligibilityLoading: true,
      deletionEligibilityError: '',
      deletionLoading: false,
      deletionDialog: false,
      deletionStep: 'reauth',
      deletionPassword: '',
      deletionCode: '',
      deletionConfirmation: '',
      deletionEmail: '',
      deletionError: '',
      locale_options: [
        {
          text: 'English',
          value: 'en',
        },
        {
          text: 'Spanish',
          value: 'es',
        },
      ],
    };
  },
  mounted() {
    this.init();
    this.loadDeletionEligibility();
  },
  methods: {
    async loadDeletionEligibility() {
      this.deletionEligibilityError = '';
      try {
        const { data } = await apiClient.get('/account-deletion/eligibility');
        this.deletion = data;
      } catch (error) {
        const responseMessage =
          error &&
          error.response &&
          error.response.status === 403 &&
          error.response.data &&
          error.response.data.message;
        this.deletionEligibilityError =
          responseMessage || this.$t('Settings.Common.deleteAccountLoadError');
      } finally {
        this.deletionEligibilityLoading = false;
      }
    },
    async beginDeletionRequest() {
      this.deletionLoading = true;
      this.deletionError = '';
      try {
        const { data } = await apiClient.get('/account-deletion/eligibility');
        this.deletion = data;
        if (!data.enabled || data.request) return;
        if (!data.eligible) {
          this.deletionError = this.$t('Settings.Common.deleteAccountEligibilityChanged');
          return;
        }
        this.deletionDialog = true;
      } catch (error) {
        this.deletionError = this.deletionErrorFor(
          error,
          [],
          this.$t('Settings.Common.deleteAccountSubmitError')
        );
      } finally {
        this.deletionLoading = false;
      }
    },
    closeDeletionDialog() {
      this.deletionDialog = false;
      this.deletionStep = 'reauth';
      this.deletionPassword = '';
      this.deletionCode = '';
      this.deletionConfirmation = '';
      this.deletionEmail = '';
      this.deletionError = '';
    },
    async reauthenticateForDeletion() {
      this.deletionLoading = true;
      this.deletionError = '';
      try {
        await apiClient.post('/account-deletion/reauthenticate', {
          password: this.deletionPassword,
          code: this.deletionCode || undefined,
        });
        this.deletionStep = 'confirm';
        this.deletionEmail = this.deletion.email;
      } catch (error) {
        this.deletionError = this.deletionErrorFor(
          error,
          ['password', 'code'],
          this.$t('Settings.Common.deleteAccountReauthError')
        );
      } finally {
        this.deletionLoading = false;
      }
    },
    async submitDeletionRequest() {
      this.deletionLoading = true;
      this.deletionError = '';
      try {
        const { data: latest } = await apiClient.get('/account-deletion/eligibility');
        this.deletion = latest;
        if (!latest.enabled || latest.request || !latest.eligible) {
          this.deletionError = this.$t('Settings.Common.deleteAccountEligibilityChanged');
          return;
        }
        const { data } = await apiClient.post('/account-deletion/request', {
          confirmation: this.deletionConfirmation,
          email: this.deletionEmail,
        });
        this.deletion.request = data;
        this.closeDeletionDialog();
      } catch (error) {
        this.deletionError = this.deletionErrorFor(
          error,
          ['teams', 'reauthentication', 'email', 'confirmation'],
          this.$t('Settings.Common.deleteAccountSubmitError')
        );
        this.loadDeletionEligibility();
      } finally {
        this.deletionLoading = false;
      }
    },
    deletionErrorFor(error, fields, fallback) {
      const errors = error && error.response && error.response.data && error.response.data.errors;
      if (!errors) return fallback;
      for (const field of fields) {
        if (errors[field] && errors[field][0]) return errors[field][0];
      }
      return fallback;
    },
    init() {
      this.$store.dispatch('user/getUserProfile', this.$store.state.auth.user.id).then(() => {
        this.user = JSON.parse(JSON.stringify(this.$store.getters['user/profile']));
      });
    },
    update() {
      this.loading = true;
      const payload = new FormData();
      payload.append('name', this.user.name);
      payload.append('email', this.user.email);
      payload.append('phone', this.user.phone);
      payload.append('last_name', this.user.last_name);
      payload.append('locale', this.user.locale);
      payload.append('_method', 'put');
      this.$store.dispatch('user/update', payload).then(() => {
        this.$i18n.locale = this.user.locale;
        this.init();
        this.loading = false;
      });
    },
  },
};
</script>
